import React from 'react';
import PropTypes from 'prop-types';

function Repeat({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 4.5h7.3c1.12 0 1.68 0 2.1.22.38.19.69.5.88.87.22.43.22.99.22 2.11V9c0 .93 0 1.4-.15 1.77a2 2 0 0 1-1.08 1.08c-.37.15-.84.15-1.77.15M13 19.5H5.7c-1.12 0-1.68 0-2.1-.22a2 2 0 0 1-.88-.87c-.22-.43-.22-.99-.22-2.11V15c0-.93 0-1.4.15-1.77a2 2 0 0 1 1.08-1.08C4.1 12 4.57 12 5.5 12m4.8 2.5h3.4c.28 0 .42 0 .53-.05a.5.5 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-3.4c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22c-.11-.05-.25-.05-.53-.05h-3.4c-.28 0-.42 0-.53.05a.5.5 0 0 0-.22.22c-.05.11-.05.25-.05.53v3.4c0 .28 0 .42.05.53.05.1.13.17.22.22.11.05.25.05.53.05Zm7.5 7.5h3.4c.28 0 .42 0 .53-.05a.5.5 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-3.4c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22c-.11-.05-.25-.05-.53-.05h-3.4c-.28 0-.42 0-.53.05a.5.5 0 0 0-.22.22c-.05.11-.05.25-.05.53v3.4c0 .28 0 .42.05.53.05.1.13.17.22.22.11.05.25.05.53.05ZM2.8 7h3.4c.28 0 .42 0 .53-.05a.5.5 0 0 0 .22-.22C7 6.62 7 6.48 7 6.2V2.8c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22C6.62 2 6.48 2 6.2 2H2.8c-.28 0-.42 0-.53.05a.5.5 0 0 0-.22.22C2 2.38 2 2.52 2 2.8v3.4c0 .28 0 .42.05.53.05.1.13.17.22.22.11.05.25.05.53.05Z"
      />
    </svg>
  );
}

Repeat.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Repeat;
